import { render, staticRenderFns } from "./ReviewTickets.vue?vue&type=template&id=3a3f1e1f&scoped=true"
import script from "./ReviewTickets.vue?vue&type=script&lang=js"
export * from "./ReviewTickets.vue?vue&type=script&lang=js"
import style0 from "./ReviewTickets.vue?vue&type=style&index=0&id=3a3f1e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f1e1f",
  null
  
)

export default component.exports